import { OrganizationResourceTable } from './OrganizationResourceTable';
export default OrganizationResourceTable;
